import { BenefitsInsuranceStatus } from '@AMIEWEB/MarginTool/enum';
import { orderBy } from 'lodash';

const formatTypeAheadOptions = options => {
  return orderBy(options, [item => item.orderBy, 'orderBy', item => item.shiftDescription], ['asc', 'asc']).map(
    item => ({
      label: item.shiftDescription,
      object: {
        shiftId: parseInt(item?.shiftId),
        shiftDescription: item?.shiftDescription,
        hoursPerWeek: item?.hoursPerWeek,
        hoursPerShift: item?.hoursPerShift,
        rateShiftListId: item?.rateShiftListId,
        shiftTypeId: item?.shiftTypeId,
        orderBy: item?.orderBy,
      },
    }),
  );
};

const insuranceData = data => {
  return data
    ?.filter(item => item?.category === BenefitsInsuranceStatus.insuranceStatus)
    ?.flatMap(item => item?.fields)
    ?.find(field => field?.field === BenefitsInsuranceStatus.insuranceStatus)?.items;
};

const formatInsuranceTypeAheadOptions = options => {
  return orderBy(options, [item => item.id], ['asc', 'asc']).map(item => ({
    label: item.description,
    object: {
      id: parseInt(item?.id),
      description: item?.description,
    },
  }));
};

export { formatTypeAheadOptions, insuranceData, formatInsuranceTypeAheadOptions };
